// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Vh-z","innerTile":"Wh-z","heading":"Xh-z","instaTileBtn":"Yh-z","disabled":"Zh-z","instaTileElement":"_h-z","instagramPic":"ai-z"};